import { useFetchWorkers } from '@/features/devices/api/useFetchWorkers'
import { useHasAnyOutdatedDevice } from '@/features/devices/api/version'
import { AppOutdatedVersionBanner } from '@/features/devices/components/AppOutdatedVersionBanner'
import { NoDevicesPlaceholder } from '@/features/devices/components/NoDevicesPlaceholder'
import { DashboardSidebar } from './DashboardSidebar'
import { JobsChartBlock } from './JobsChartBlock'
import { PointsChartBlock } from './PointsChartBlock'
import { TopDomains } from './TopDomains'

export const Dashboard = () => {
  const isAnyWorkerOutdated = useHasAnyOutdatedDevice()
  const { data, isLoading } = useFetchWorkers(false)
  const hasAnyWorkers = !isLoading && (data?.length || 0) > 0

  return (
    <>
      {isAnyWorkerOutdated && <AppOutdatedVersionBanner />}
      <div className="max-tablet:flex-col flex flex-1">
        <div className="max-tablet:pb-8 max-tablet:pt-4 max-mobile:ml-0 max-mobile:w-auto max-mobile:pr-0 ml-4 flex flex-col pb-10">
          <div className="max-tablet:w-full max-tablet:pt-0 sticky top-[var(--header-height)] w-[270px] pt-10">
            <DashboardSidebar hasAnyWorkers={hasAnyWorkers} />
          </div>
        </div>
        {!isLoading &&
          (hasAnyWorkers ? (
            <div className="mt-4 flex flex-1 flex-col gap-4">
              <PointsChartBlock />
              <JobsChartBlock />
              <TopDomains />
            </div>
          ) : (
            <NoDevicesPlaceholder />
          ))}
      </div>
    </>
  )
}
